export enum BookingProductStepEnum {
  Init = 0,
  ProductSelection = 10,
  ShowProductConfigurationPage = 15,
  ExtraProductSelection = 20,
  Authentication = 30,
  Payment = 40,
}
